module.exports = "https://cdn.dove.it/_next/static/public/assets/agents/graziani.4c7d63ea4535453873883ddf35571556.png";